module.exports = __webpack_public_path__ + "static/13-2e1b284cbd48067f9b9e5d734dfcdaac.jpg";